<template>
<div class="account-manage-warpper">
  <el-form  :model="userInfo" :label-position="labelPosition" :rules="rules" ref="rulesForm" label-width="120px">
    <el-form-item>
      <h2>账户信息</h2>
      <!-- <h5>{{userInfo.email}}</h5> -->
    </el-form-item>
    <el-form-item label="电子邮件">
      <el-input v-model="userInfo.email" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="账号">
      <el-input v-model="userInfo.name" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="邮箱接收告警" v-if="alarmItem">
      <el-switch active-color="#207AE8" v-model="userInfo.additionalInfo.alarmFromEmail"></el-switch>
    </el-form-item>
    <el-form-item label="联系手机" prop="phone">
      <el-input v-model="userInfo.phone" :disabled="readOnly"></el-input>
    </el-form-item>
    <el-form-item label="手机接收告警" v-if="alarmItem">
      <el-switch active-color="#207AE8" v-model="userInfo.additionalInfo.alarmFromSms" @change="alarmSwitch"></el-switch>
    </el-form-item>
    <el-form-item label="昵称" prop="lastName">
      <el-input v-model="userInfo.lastName" :disabled="readOnly"></el-input>
    </el-form-item>
    <el-form-item>
      <changePassword />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" :disabled="allowSave" @click="submitSaveUser">保存</el-button>
      <el-button @click="copyToken" class="copyButton">复制API Token</el-button>
    </el-form-item>
  </el-form>
  <input style="display: none" type="text" :value="token" id="tokenTarget">
</div>
</template>

<script>
import changePassword from './changePassword'
import { getUser, saveUser } from '@/api/user-controller/'
import _ from 'lodash'

export default {
  name: 'accountManage',
  components: {
    changePassword
  },
  inject: ['reload'],
  data () {
    // const validateName = (rule, value, callback) => {
    //   if (value[0] !== ' ') {
    //     callback()
    //   } else {
    //     callback(new Error('不允许空格'))
    //   }
    // }
    const validatePhone = (rule, value, callback) => {
      // const valid = /(13\d|14[579]|15[^4\D]|17[^49\D]|18\d)\d{8}/g
      const valid = /^1\d{10}$/
      if (valid.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确手机号'))
      }
    }
    return {
      dialogVisible: false,
      labelPosition: 'right',
      token: this.$store.state.user.token,
      phone: '',
      userInfo: {},
      OldUserInfo: {},
      modedUserInfo: {},
      readOnly: false,
      alarmItem: false,
      rules: {
        lastName: [
          // { validator: validateName, trigger: 'blur' },
          { max: 16, message: '昵称输入不可超过16位', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系手机', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    getUser(this.$store.state.user.id).then(val => {
      // console.log(val.data, '-------11')
      this.userInfo = Object.assign({}, val.data)
      this.OldUserInfo = Object.assign({}, val.data)
      if (this.userInfo.authority === 'SYS_ADMIN') {
        this.readOnly = true
      }
      this.userInfo.additionalInfo = JSON.parse(this.userInfo.additionalInfo)
      if (this.userInfo.authority === 'TENANT_ADMIN') {
        this.alarmItem = true
      }
      console.log(this.userInfo, '-------11')
    })
  },
  methods: {
    alarmSwitch () {
      if (this.userInfo.alarmFromSms) {
        if (this.userInfo.phone === '') {
          this.$message.error('打开手机接收告警，必须先填写手机号')
          this.userInfo.alarmFromSms = false
        }
      }
    },
    copyToken () {
      this.$copyText('Bearer ' + this.token).then((e) => {
        console.log(e)
        this.$message({
          type: 'success',
          message: '复制 API Token 成功'
        })
      })
    },
    submitSaveUser () {
      this.$refs.rulesForm.validate(valid => {
        if (valid) {
          this.userInfo.additionalInfo = JSON.stringify(this.userInfo.additionalInfo)
          // for (const item in this.userInfo) {
          //   if (item === 'phone' || item === 'alarmFromEmail' || item === 'alarmFromSms') {
          //     tempInfo[item] = this.userInfo[item]
          //   }
          // }
          // delete this.userInfo.alarmFromSms
          // delete this.userInfo.alarmFromEmail
          this.userInfo.lastName = this.userInfo.lastName.trim()
          // this.userInfo.additionalInfo = JSON.stringify(tempInfo)
          console.log(this.userInfo, '----submit')
          saveUser(this.userInfo).then(() => {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.reload()
          }).catch(err => console.log(err))
        } else {
          this.$message.error('请填写符合提示的信息')
          return false
        }
      })
    }
  },
  computed: {
    allowSave: function () {
      if (_.isEqual(this.userInfo, this.OldUserInfo)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted: function () {
  }
}
</script>

<style lang="scss" scoped>
.account-manage-warpper{
  padding: 20px;
  .el-form {
    max-width: 600px;
  }
}
.el-form-item{
  h2,h5{
    margin: 0;
    color: #4b4c50;
  }
  h2{
    line-height: 35px;
  }
  h5{
    font-size: 16px;
    line-height: 18px;
    font-weight: 300;
  }
}
</style>
